






































import { Component, Vue, Prop, Watch, Mixins } from "vue-property-decorator";

import NavigationItem from "./NavigationItem.vue"
import { isProgramActive, isInfoPageActive, isCatalogActive, isAppointmentActive, isCommitteesActive } from "@service/helpers/tabActiveHandler";
import { RouterPath, NavigationItem as NavItemModel, NavbarTab } from "@service/types/NavbarTab";
import MoreBtn from '../../../assets/svg/more.svg';

import catalogDefaults from "../../../types/catalogDefaults";

import {ArrayHelpers} from "@common/ArrayHelpers";
import { TabIdEnum } from "@service/types/TabIdEnum";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
import { Debounce } from "vue-debounce-decorator";
import debounce from "lodash.debounce";
import { IsMeetingsEnabled } from "@mixins/isMeetingsEnabled";
import { ActiveTabHelper } from "@service/components/navbar/helpers/ActiveTabHelper";
import { getServiceParamValue } from "@common/serviceParamsHelper";
import { TicketAdminGroupType } from "@share/ticketSystem/enums/TicketAdminGroupTypes";
import { getIsCommitteeAllowed } from "@share/common/helpers/ticketSystemHelpers";

@Component({ components: { NavigationItem , MoreBtn} })
export default class NavigationList extends Mixins(IsMeetingsEnabled) {

    /**
     * current user has group, wich restrict user interface
     */
    @Prop({ default: false }) isRestrictedPartner: boolean;
    @Prop({ default: false }) ticketSystemIsEnabled: boolean;

    tabs: NavItemModel[] = [];
    isMenuOpen = false;
    showMoreButtonForDesktop = false;
    containerResizeObserver: ResizeObserver | null = null;
    additionalList:  NavbarTab[] = [];
    activeTabHelper: ActiveTabHelper | null = null;

    mounted() {
        this.setResizeObserver();
        this.activeTabHelper = new ActiveTabHelper(this);

        if(this.isRestrictedPartner) {
            this.setTabsForRestricted();
            return
        }

        if(this.ticketSystemIsEnabled) {
            this.setTicketSystemsTabs();
            return;
        }

        this.tabs = Vue.observable([
            {
                title: TabIdEnum.stage,
                isActive: true,
                defaultRoute: 'Home',
                defaultParams: {
                    query: {}
                },
                routes: ['Home', 'EditMeeting'],
                currentLink: {} as RouterPath,
                isActiveHandler: isProgramActive,
                tabId: TabIdEnum.stage,
                index: 0
            },
            {
                title: TabIdEnum.participants,
                isActive: false,
                defaultRoute: 'Participants',
                routes: ['Participants', 'Participant'],
                currentLink: {} as RouterPath,
                tabId: TabIdEnum.participants,
                index: 30
            }
        ]);

        const userGroupIds = this.$store.getters['groupIds'];
        const infoParams = this.$store.getters['events/selectedEventViewParam']('info', null);

        if(infoParams) {
            if(Array.isArray(infoParams)) {
                infoParams.forEach((infoParamsItem, index) => {
                    this.addInfoPageTab(infoParamsItem, userGroupIds, index)
                });
            }
            else if(typeof infoParams === "object") {
                this.addInfoPageTab(infoParams, userGroupIds)
            }
        }

        const meetingsScheduleParams = this.$store.getters['events/selectedEventViewParam']('meetingsSchedule', null);

        if(meetingsScheduleParams?.isEnabled) {
            this.tabs.push({
                title: 'meetings-schedule',
                isActive: false,
                defaultRoute: RouteNamesEnum.meetingsSchedule,
                routes: [RouteNamesEnum.meetingsSchedule],
                currentLink: {} as RouterPath,
                tabId: 'meetings-schedule',
                index: 100
            })
        }

        if (this.isExpertRatingsEnabled) {
            this.tabs.push({
                title: 'expert-ratings',
                isActive: false,
                defaultRoute: 'ExpertRatings',
                routes: ['ExpertRatings', 'ExpertRatingsPage', 'RatingsSummary'],
                currentLink: {} as RouterPath,
                tabId: 'expert-rating',
                index: 110
            });
        }

        this.catalog.forEach((element, index) => {
            this.tabs.push({
                title: element.schemaId,
                isActive: false,
                defaultRoute: 'Partners',
                defaultParams: {
                    params: {
                        schemaId: element.schemaId
                    }
                },
                routes: ['Partners', 'Partner'],
                currentLink: {} as RouterPath,
                isActiveHandler: isCatalogActive,
                tabId: `catalog-${element.schemaId}`,
                index: 40 + index
            });
        });
    }

    beforeDestroy() {
        window.removeEventListener('resize', this.resizeHandler);
        this.containerResizeObserver?.disconnect();
    }

    setResizeObserver() {

        this.resizeHandler();

        //debounce with decorator does not allow event emit
        const handler = debounce(() => {
            this.resizeHandler()
        }, 50);

        if(ResizeObserver) {
            this.containerResizeObserver = new ResizeObserver(handler);
            const container = this.$el.getElementsByClassName('header-nav__container')[0];
            if(container) {
                this.containerResizeObserver.observe(container);
            }
        }
        else {
            this.addResizeHandler();
        }
    }

    addResizeHandler() {
        window.addEventListener('resize', this.resizeHandler)

        this.$nextTick(() => {
            this.resizeHandler();
        })
    }

    @Debounce(50)
    resizeHandler() {

        const container = this.$el.getElementsByClassName('header-nav__container')[0];
        const listItems = container.getElementsByTagName("li");

        if(container) {
            let targetWidth = 0;

            const lastVisibleItemIndex = Array.from(listItems).findIndex((listItem: HTMLElement) => {
                targetWidth+= listItem.clientWidth;
                return container.clientWidth <= targetWidth;
            })

            this.additionalList = this.list.slice(lastVisibleItemIndex)
            this.showMoreButtonForDesktop = container.scrollWidth > container.clientWidth;
        }
    }

    @Watch("isRestrictedPartner")
    watchIsRestrictedPartner() {
        if(this.isRestrictedPartner) {
            this.setTabsForRestricted();
        }
    }

    @Watch("ticketSystemIsEnabled")
    watchTicketSystemIsEnabled() {
        if(this.ticketSystemIsEnabled) {
            this.setTicketSystemsTabs();
        }
    }

    openMenu() {
        this.isMenuOpen = !this.isMenuOpen;
        if (this.isMenuOpen) {
            setTimeout(() => {
                document.body.addEventListener('click', this.handleClick)
            }, 50);
        }
    }

    handleClick() {
        this.isMenuOpen = false;
        document.body.removeEventListener('click', this.handleClick)
    }

    setTicketSystemsTabs() {
        const tabs: NavItemModel[] = [
            {
                title: "ticketSystemIdeas",
                isActive: false,
                defaultRoute: RouteNamesEnum.ticketSystemIdeas,
                routes: [RouteNamesEnum.ticketSystemIdeas],
                currentLink: {} as RouterPath,
                tabId: TabIdEnum.ticketSystemIdeas,
                index: 120
            },
            {
                title: "ticketSystemProblems",
                isActive: false,
                defaultRoute: RouteNamesEnum.ticketSystemProblems,
                routes: [RouteNamesEnum.ticketSystemProblems],
                currentLink: {} as RouterPath,
                tabId: TabIdEnum.ticketSystemProblems,
                index: 121
            },
        ];
        if (this.isTicketAdmin) {
            tabs.push({
                title: "ticketSystemDashboard",
                isActive: false,
                defaultRoute: RouteNamesEnum.ticketSystemDashboard,
                routes: [RouteNamesEnum.ticketSystemDashboard],
                currentLink: {} as RouterPath,
                tabId: TabIdEnum.ticketSystemDashboard,
                index: 125
            })
        }

        if(getIsCommitteeAllowed(this.$store.getters["groupIds"])) {
            tabs.push({
                title: "committees",
                isActive: false,
                defaultRoute: RouteNamesEnum.committeesList,
                routes: [RouteNamesEnum.committeesList],
                currentLink: {} as RouterPath,
                tabId: TabIdEnum.committees,
                index: 122
            })
        }

        this.tabs = Vue.observable(tabs);
    }

    setTabsForRestricted() {
        this.tabs = [
            {
                title: catalogDefaults[0].schemaId,
                isActive: false,
                defaultRoute: 'Partners',
                defaultParams: {
                    params: {
                        schemaId: catalogDefaults[0].schemaId
                    }
                },
                routes: ['Partners', 'Partner'],
                currentLink: {} as RouterPath,
                isActiveHandler: isCatalogActive,
                tabId: `catalog-${catalogDefaults[0].schemaId}`,
                index: 40
            }
        ]
    }

    isInfoEnabled(infoParams: any): boolean {
        return infoParams && infoParams.schemaId && infoParams.objectId;
    }

    addInfoPageTab(infoParams: any, userGroupIds: any, index = 0) {
        let infoGroupAccess = true;
        if(infoParams?.groupIds) {
            infoGroupAccess = !!ArrayHelpers.intersect(userGroupIds, infoParams?.groupIds).length;
        }

        if (this.isInfoEnabled(infoParams) && infoGroupAccess) {

            this.tabs.push({
                title: infoParams?.title,
                isActive: false,
                defaultRoute: 'Info',
                isActiveHandler: isInfoPageActive,
                defaultParams: {
                    params: {
                        objectId: infoParams.objectId
                    }
                },
                routes: ['Info'],
                currentLink: {} as RouterPath,
                tabId: `info-${infoParams.objectId}`,
                index: 100 + index
            });
        }
    }

    itemIsActive(item: NavbarTab) {
        return item.isActive || this.isAppointmentActive(item) || this.isCommitteesActive(item);
    }

    isCommitteesActive(item: NavbarTab) {
        return item.tabId === TabIdEnum.committees && isCommitteesActive(this.$route);
    }

    isAppointmentActive(item: NavbarTab) {
        return item.tabId === 'meetings-schedule' && isAppointmentActive(this.$route)
    }

    get catalog(): Array<Record<string, any>> {
        return this.$store.getters['events/selectedEventViewParam']('catalog', null) || catalogDefaults;
    }

    get currentRouterName(): string {
        return this.$route.name as string;
    }

    get list() {
        return this.tabs.sort((a,b) => a.index - b.index).map((item) => {
            if (item.isActiveHandler && typeof item.isActiveHandler == 'function') {
                item.isActive = item.isActiveHandler(item, this.$route);
            }
            else {
                if (item.routes.indexOf(this.currentRouterName) > -1) {
                    item.isActive = true
                } else {
                    item.isActive = false;
                }
            }

            if (item.isActive) {
                const currentLink: RouterPath = {
                    query: this.$route.query,
                    hash: ['#notifications', '#settings'].indexOf(this.$route.hash) >= 0 ? '' : this.$route.hash,
                    name: '',
                    params: null
                }
                if (item.tabId.indexOf('catalog') >= 0) {
                    currentLink.name = 'Partners';
                    currentLink.params = Object.assign({}, this.$route.params, { id: null });
                } else {
                    currentLink.name = this.$route.name?.toString() || '';
                    currentLink.params = this.$route.params;
                }
                item.currentLink = currentLink;
            }
            return item;
        })
    }

    /**
     * флаг необходимости таба с экспертными оценками
     */
    get isExpertRatingsEnabled(): boolean {
        const expertRatingsParams = this.$store.getters['events/selectedEventViewParam']('expertRatings', null);

        return (expertRatingsParams?.isEnabled === true)
            && ((Array.isArray(expertRatingsParams?.groupIds)
            && ArrayHelpers.intersect(expertRatingsParams.groupIds, this.$store.state.session.profile?.groupIds ?? []).length > 0)
            || this.$store.getters['isAdmin']);
    }

    // идентификаторы групп администраторов тикетной системы
    get adminGroupIds() {
        return [
            ...(getServiceParamValue('ticketSystem', TicketAdminGroupType.ideasAdministrationGroupIds) as string[] ?? []),
            ...(getServiceParamValue('ticketSystem', TicketAdminGroupType.problemsAdministrationGroupIds) as string[] ?? []),
        ];
    }

    get isTicketAdmin() {
        return ArrayHelpers.intersect(this.adminGroupIds, this.$store.getters['groupIds'] || []).length > 0;
    }
}
